<template>
    <dl class="padtb clearfix">
        <dt><img :src="getImgSrc(listData.thumb)" alt="" title=""
                 onerror="javascript:this.src='//img.allfootballapp.com/www/M00/24/57/CggEnlmtMdmAaQT0AAAKHZCNxeo149.jpg'"><img
            v-show="listData.is_video" src="../assets/home/icon_video_playing.png" class="video"></dt>
        <dd>
            <p v-show="listData.title" class="listTitle"
               style="overflow : hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">
                <!-- <a :href="'./news'+'?id='+listData.id+'&firstTitle='+firstTit+'&subtitle='+subtit" style="overflow : hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;  ">{{listData.title}}</a> -->
                {{listData.title}}
            </p>
            <p class="infor clearfix">
                <span class="fl dotwrap" v-show="listData.top"><img src="../assets/home/home_bluedot.png" class="dot">Top</span>
                <span class="fr messagewrap" v-if="listData.comments_total">{{listData.comments_total}}<img
                    src="../assets/home/home_message.png" class="message"></span>
            </p>
        </dd>
    </dl>
</template>

<script>
    export default {
        name: '',
        data: function () {
            return {
                listDataDetail: {},
            };
        },
        props: ['listData', 'subtit', 'firstTit'],
    };
</script>
<style lang="less" scoped>
    .fr {
        float: right !important;
    }

    .padtb {
        padding: .8rem .7rem .5rem;
        border-bottom: .05rem solid #eff1f4;
    }

    .padtb dt {
        width: 24%;
        overflow: hidden;
        float: left;

        margin-right: 3%;
        position: relative;
    }

    .padtb dd {
        float: left;
        width: 70%;
    }

    .padtb dd p {
        font-size: 0.9rem;
        line-height: 1.4rem;
        text-align: left;
        width: 100%;
    }

    .infor {
        width: 100%;
    }

    .dot {
        width: .15rem;
        height: .2rem;
        overflow: hidden;
        display: inline-block;
        color: #4782c4;
        float: left;
        margin: .4rem .3rem 0 0;
    }

    .message {
        width: .9rem;
        height: auto;
        display: inline-block;
        float: right;
        margin: .1rem 0 0 .3rem;
    }

    .infor span {
        float: left;
        line-height: 1rem;
    }

    .dotwrap {
        color: #4782c4;
        font-size: .68rem;
    }

    .messagewrap {
        color: #8c9399;
        font-size: .68rem;
    }

    .listTitle a {
        color: #2d2f32;
        text-decoration: none !important;
    }

    .listTitle a:visited {
        color: #888;
    }

    .video {
        display: block;
        position: absolute;
        width: 1.6rem;
        left: 50%;
        margin-left: -0.8rem;
        height: 1.6rem;
        top: 50%;
        margin-top: -0.8rem;
    }

    .padtb dd p.listTitle {
        min-height: 2.8rem;
        line-height: 1.36rem;
    }
</style>



// WEBPACK FOOTER //
// listItem.vue?bc767740